export const PROFILE = "profile";
export const ORDERHISTORY = "orderHistory";